export const handleError = (error, dispatch, toast, code) => {
  console.error({ error })
  if (error.code !== 'permission-denied' ) {
    toast.error(error.message, { autoClose: 2500, position: 'top-left' })
  }
  dispatch({
    type: code,
    payload: error.message,
  })
}
